module.exports = __webpack_public_path__ + "img/htkj_11.04288527.jpg";